<template>
  <div type="flex" class="home-top-assembly-mian">
    <div class="top-assembly-left left">
      <!-- <span class="mar-ju">海口市</span>
      <img class="ico" src="../../assets/homeNew/content2.png" />
      <span>20℃/31℃</span>
      <span class="mar-ju">空气质量 26 <label class="color_15D6A0">优</label></span>-->
      <iframe scrolling="no" src="http://i.tianqi.com/index.php?c=code&amp;id=38&amp;icon=1&amp;num=2&amp;align=left&color=%23FFFFFF" frameborder="0"
        width="400" height="75" allowtransparency="true"></iframe>
<!--      <iframe width="450" scrolling="no" height="80" frameborder="0" allowtransparency="true" color="#FFFFFF"
              src="http://i.tianqi.com/index.php?c=code&amp;id=38&amp;icon=1&amp;num=2&amp;align=left"></iframe>-->
    </div>
    <div class="top-assembly-name">
      智慧可视化系统
    </div>
    <div class="top-assembly-left top-assembly-right">
      <span class="mar-ju">{{ year }}.{{ month > 9 ? month : '0' + month }}.{{ date > 9 ? date : '0' + date }}</span>
      <span class="mar-ju">{{ week }} {{ h > 9 ? h : '0' + h }}:{{ m > 9 ? m : '0' + m }}:{{ s > 9 ? s : '0' + s }}</span>
    </div>

  </div>
</template>

<script>
import resize from './mixins/resize'
import moment from "moment";
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    }
  },
  data() {
    return {
      h: "",
      m: "",
      s: "",
      day: "",
      week: "",
      year: "",
      month: "",
      date: ""
    }
  },
  watch: {

  },
  created() {
    moment.locale("ZH_cn");
    this.nowTimes()
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    timeFormate(timeStamp) {
      this.h = Number(moment(timeStamp.getTime()).format("HH")),
        this.m = Number(moment(timeStamp.getTime()).format("mm")),
        this.s = Number(moment(timeStamp.getTime()).format("ss")),
        this.day = Number(moment(timeStamp.getTime()).format("a")),
        this.week = moment(timeStamp.getTime()).format("dddd"),
        this.year = Number(moment(timeStamp.getTime()).year()),
        this.month = Number(moment(timeStamp.getTime()).month() + 1),
        this.date = Number(moment(timeStamp.getTime()).date())
    },

    nowTimes() {

      this.timeFormate(new Date());

      setInterval(this.nowTimes, 1000);

      this.clear()

    },

    clear() {
      clearInterval(this.nowTimes)
      this.nowTimes = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.home-top-assembly-mian {
  position: relative;
  width: 100%;
  height: 85px;
  background-image: url('../../assets/homeNew/content1.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .top-assembly-name {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 0px 7px 6px rgba(0, 8, 37, 0.14);
    background: linear-gradient(132deg, #FFFFFF 0%, #CFE6FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 10px;
  }

  .top-assembly-left {
    position: absolute;
    bottom: 0;
    height: 44px;
    width: 28%;
    display: flex;
    justify-content: center;
    align-items: center;

    .ico {
      width: 27px;
      height: 20px;
      display: block;
      margin-right: 5px;
    }

    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
    .mar-ju {
      margin: 0 25px;
    }

    .color_15D6A0 {
      color: #15D6A0;
      font-size: 16px;
    }
  }

  .left {
    left: 0;
  }


  .top-assembly-right {
    right: 0;

    .mar-ju {
      margin: 0 10px;
    }
  }

}


@media screen and (max-width: 1600px) {
  .home-top-assembly-mian {
    width: 100%;
    height: 63px;

    .top-assembly-name {
      font-size: 25px;
    }

    .top-assembly-left {
      height: 30px;

      .ico {
        width: 20px;
        height: 15px;
        margin-right: 3px;
      }

      span {
        font-size: 12px;
      }

      .mar-ju {
        margin: 0 20px;
      }

      .color_15D6A0 {
        font-size: 12px;
      }

    }

    .top-assembly-right {
      .mar-ju {
        margin: 0 7px;
      }
    }

  }

}
</style>
